class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;
    
    // Check if this is a mega menu (has .mega-menu class)
    if (this.mainDetailsToggle && this.mainDetailsToggle.classList.contains('mega-menu')) {
      this.setupHoverEvents();
    }
  }

  setupHoverEvents() {
    if (!this.mainDetailsToggle) return;
    
    const summary = this.mainDetailsToggle.querySelector('summary');
    const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
    
    if (!summary) return;
    
    // Only enable hover on desktop (990px and above)
    const mediaQuery = window.matchMedia('(min-width: 990px)');
    
    const handleMouseEnter = () => {
      if (!mediaQuery.matches) return;
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
      this.openOnHover();
    };
    
    const handleMouseLeave = () => {
      if (!mediaQuery.matches) return;
      this.hoverTimeout = setTimeout(() => {
        this.closeOnHover();
      }, 150); // Small delay to allow moving to content
    };
    
    // Open on hover over summary or details element
    this.mainDetailsToggle.addEventListener('mouseenter', handleMouseEnter);
    this.mainDetailsToggle.addEventListener('mouseleave', handleMouseLeave);
    
    // Keep open when hovering over content
    if (content) {
      content.addEventListener('mouseenter', () => {
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }
      });
      
      content.addEventListener('mouseleave', handleMouseLeave);
    }
  }

  openOnHover() {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    }
  }

  closeOnHover() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.removeAttribute('open');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
